import BaseView from "./_BaseView";
import Table from "../components/Table";
import Api from "../Api";
import Confirm from "../components/Confirm";

export default class InstanceView extends BaseView {
    constructor() {
        super();
        this.modalClasses = 'larger-modal allow-enter';
        this.formSelector = '#instanceForm';
        this.formUrl = '/api/instances';
        this.formTpl = 'instance-form';
        this.formTitle = Lang.InstanceViewTitle;
        this.defaultObject = {
            title: '',
            desc: '',
        };
        this.formCallback = function () {
            this.table.reload();
        };
    }

    init() {
        super.init();

        if ($('#instances').length > 0) {
            this.table = new Table('instances', '/api/instances/table', [
                // { data: 'select', orderable: true},
                {data: 'domain'},
                {data: 'applications'},
                {data: 'tools', orderable: false},
            ]);
        }
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const container = $('#instances');

        $('.add-instance').on('click', function () {
            self.renderForm();
            return false;
        });

        container.on('click', '.edit', function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/instances/${id}`).done(function (r) {
                self.renderForm(r);
            });
            return false;
        });

        container.on('click', '.delete', function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(1)').text();

            Confirm({
                ok: Lang.delete,
                title: name,
                msg: `<strong>${Lang.deleterelated}</strong><br>${Lang.delsure}`,
                onConfirm: function () {
                    Api.send(`/api/instances/${id}`, {}, 'delete').done(function () {
                        self.table.reload();
                    });
                }
            });
            return false;
        });
    }
}
